module.exports = __webpack_public_path__ + "static/img/上.e564ccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/上.png
// module id = 6FON
// module chunks = 16